import { Grid } from "@mui/material";
import { Container, Skeleton, Box } from "@mui/material";
import PaymentSummery from "../Components/Checkout/paymentSummery";

import React from "react";
import CheckoutPanel from "../Components/Home/CheckoutPanel";
import BackBar from "../Components/Shared/BackBar";

export const SET_FINAL_PAY = "SET_FINAL_PAY"

const CheckoutPage = () => {
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        {/* <BackBar /> */}
      </Grid>
      <Grid item xs={12}>
        <CheckoutPanel />
      </Grid>
    </Grid>
  );
};

export default CheckoutPage;
